import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';
import { motion } from 'framer-motion';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const EnergyInvestmentChart = () => {
  const data = {
    labels: ['Nigeria', 'Equatorial Guinea', 'Ghana', 'Senegal', 'Mozambique', 'Angola'],
    datasets: [
      {
        label: 'Investment ($b)',
        data: [15, 8, 5, 12, 20, 10],
        backgroundColor: '#35475e',
        borderRadius: 6,
        borderSkipped: false,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        callbacks: {
          label: (context) => {
            const labels = [
              'NLNG Train-7 / GGGP [$15b]',
              'Gas Mega Hub [$8b]',
              'Offshore Drilling [$5b]',
              'GTA LNG [$12b]',
              'Coral South FLNG [$20b]',
              'Offshore Expansion [$10b]',
            ];
            return labels[context.dataIndex];
          },
        },
      },
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Investment ($b)',
          font: {
            weight: 'bold',
            size: 14,
          },
        },
      },
      x: {
        title: {
          display: true,
          text: 'Country',
          font: {
            weight: 'bold',
            size: 14,
          },
        },
      },
    },
  };

  return (
    <motion.div
      className="chart-container"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true, amount: 0.2 }}
    >
      <h2 style={{ textAlign: 'center', fontWeight: 'bold', marginBottom: '1rem' }}>
        West Africa Energy Investment
      </h2>
      <p style={{ textAlign: 'center', color: '#8a6f2f', marginBottom: '1rem', fontSize: '14px' }}>
        (West Africa Energy Investment Opportunities showing $70 billion total potential across six key markets)
      </p>
      <div style={{ width: '100%', maxWidth: '900px', height: '400px', margin: '0 auto' }}>
        <Bar data={data} options={options} />
      </div>
    </motion.div>
  );
};

export default EnergyInvestmentChart;
